/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemText } from "./d-theme-dark-menu-item-expandable-item-text";

export class DThemeDarkMenuSidedItemExpandableItemText extends DThemeDarkMenuItemExpandableItemText {}
